export default class ValidationAndErrorHandling {
  constructor(loaderTarget, errorMessageTarget, fromSiteBuilderValue = false) {
    this.loaderTarget = loaderTarget;
    this.errorMessageTarget = errorMessageTarget;
    this.fromSiteBuilderValue = fromSiteBuilderValue;
  }

  isAspectRatioValid(width, height) {
    return height * 105 < width || width * 105 < height;
  }

  isValidImageSize(width, height) {
    return width <= 8000 && height <= 6000 && !this.isAspectRatioValid(width, height);
  }

  handleFileValidation(file, isValidFileType) {
    const { size: fileSize, type: fileType } = file;
    const maxFileSizeMb = 50;

    if (fileSize > maxFileSizeMb * 1000000 || !isValidFileType(fileType)) {
      this.handleImageError("size");
      return false;
    }

    if (fileSize === 0) {
      this.handleImageError("empty");
      return false;
    }

    return true;
  }

  handleImageError(errorType) {
    const link = '<a href="https://support.lawlytics.com/s/article/How-to-Add-Images-or-Videos-to-a-Page" target="_blank">Learn More</a>';
    const warningIcon = '<span class="material-icons-outlined">warning</span>';
    const errorMessage = {
      size: `File upload failed. Files must meet specific dimension, file size, and type requirements. ${link}`,
      empty: "The selected file is empty. Choose a valid file.",
      corrupted: "The uploaded file appears to be corrupted. Try uploading a different file.",
    };

    this.hideLoader();
    const icon = this.fromSiteBuilderValue ? warningIcon : '';
    this.errorMessageTarget.innerHTML = `${icon} ${errorMessage[errorType]}`;
    this.errorMessageTarget.classList.add('error-active');
  }

  clearError() {
    this.errorMessageTarget.innerHTML = '';
    this.errorMessageTarget.classList.remove('error-active');
  }

  hideLoader() {
    this.loaderTarget.classList.remove("media__loader--visible");
  }
}
